module.exports = __webpack_public_path__ + "header_placeholder.jpg?578f4c4116948a4ec0c5e4c99045703f";